import { subscriptionKeys } from 'core/utils/query-key-factory';
import { useServices } from 'hooks';
import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';

export const useGetSubscriptionPreferences = (token: string) => {
	const { api } = useServices();
	const [enabled, setEnabled] = useState(!!token);

	const query = useQuery({
		queryKey: subscriptionKeys.preference(token),
		queryFn: () =>
			api
				.getSubscriptionPreferences(token)
				.then(response => response.data),
		enabled: enabled,
	});

	// `onSettled` was removed from `useQuery` in react-query v5. Replicate the
	// previous run-once behaviour by disabling the query once it has settled.
	useEffect(() => {
		if (query.isFetched) {
			setEnabled(false);
		}
	}, [query.isFetched]);

	return query;
};
